import React, { useEffect, useState, useMemo } from 'react';
import { Collapse, Icon } from 'antd';
import { Widget, Row, Table, ColumnProps, FormInput, Col, FormResetButton, Form, Button, FormatText } from '@digital/ui';
import { CicloOrcamentarioProjetoPacote, CicloOrcamentarioProjetoPacoteResult, getCicloOrcamentarioProjetoPacote, getCicloOrcamentarioProjetoPacoteExportaExcel } from '@app/api/relatorioCicloorcamentario';
import { newGuid } from '@app/helpers/generatorGuid';
import { PaginationConfig } from 'antd/lib/pagination';
import LinkRequisitadoProjeto from '../../components/linkRequisitadoProjeto';
import { formatCurrencyBr } from '@app/helpers/numbers';
import AbaCicloOrcamentarioPacoteTabela from './AbaCicloOrcamentarioPacoteTabela';
const { Panel } = Collapse;

interface tipoColuna {
  colunaPrincipal: string;
  colunaSegundaria: string;
  valor: string;
  descricaoDataIndex: string;
}
interface PropAbaPacote {
  projetoId: string;
  pageSize: number;
}

const AbaPacote = (props: PropAbaPacote) => {
  const { projetoId, pageSize } = props;
  const [totalizador, setTotalizador] = useState<tipoColuna[]>([]);
  const [cicloOrcamentarioProjetoPacote, setCicloOrcamentarioProjetoPacote] = useState<CicloOrcamentarioProjetoPacote>();


  const [valorTotalA, setValorTotalA] = useState('0');
  const [valorTotalB, setValorTotalB] = useState('0');
  const [valorTotalC, setValorTotalC] = useState('0');
  const [valorTotalD, setValorTotalD] = useState('0');
  const [valorTotalE, setValorTotalE] = useState('0');
  const [valorTotalF, setValorTotalF] = useState('0');
  const [valorTotalG, setValorTotalG] = useState('0');
  const [valorTotalH, setValorTotalH] = useState('0');

  const calcularTotal = (() => {
    if (cicloOrcamentarioProjetoPacote) {
      setValorTotalA(cicloOrcamentarioProjetoPacote.valorTotalA);
      setValorTotalB(cicloOrcamentarioProjetoPacote.valorTotalB);
      setValorTotalC(cicloOrcamentarioProjetoPacote.valorTotalC);
      setValorTotalD(cicloOrcamentarioProjetoPacote.valorTotalD);
      setValorTotalE(cicloOrcamentarioProjetoPacote.valorTotalE);
      setValorTotalF(cicloOrcamentarioProjetoPacote.valorTotalF);
      setValorTotalG(cicloOrcamentarioProjetoPacote.valorTotalG);
      setValorTotalH(cicloOrcamentarioProjetoPacote.valorTotalH);
    }
  });

  useEffect(calcularTotal, [cicloOrcamentarioProjetoPacote]);


  useMemo(() => {
    if (projetoId) {
      getCicloOrcamentarioProjetoPacote(projetoId).then(data => {
        if (data) {

          data.result.map((ordemInvestimento) => {
            let index = 1;
            if (ordemInvestimento.children) {
              ordemInvestimento.children.filter((pacote) => {
                pacote.codPacote = index.toString();
                index++;
              });
            }
          });
        }
        setCicloOrcamentarioProjetoPacote(data);
      });
    }
  }, [projetoId]);

  useEffect(() => {
    if (cicloOrcamentarioProjetoPacote) {
      let array = [
        {
          colunaPrincipal: 'A',
          colunaSegundaria: 'Orçado',
          valor: `${valorTotalA}`,
          descricaoDataIndex: 'orcadoAnoFormatado',
        },
        {
          colunaPrincipal: 'B',
          colunaSegundaria: 'Contratado',
          valor: `${valorTotalB}`,
          descricaoDataIndex: 'contratadoFormatado',
        },
        {
          colunaPrincipal: 'C',
          colunaSegundaria: 'Executado',
          valor: `${valorTotalC}`,
          descricaoDataIndex: 'executadoFormatado',
        },
        {
          colunaPrincipal: 'D',
          colunaSegundaria: 'Requisitado',
          valor: `${valorTotalD}`,
          descricaoDataIndex: 'requisitadoFormatado',
        },
        {
          colunaPrincipal: 'E = B - C + D',
          colunaSegundaria: 'Compromissado',
          valor: `${valorTotalE}`,
          descricaoDataIndex: 'compromissadoFormatado',
        },
        {
          colunaPrincipal: 'F',
          colunaSegundaria: 'A Contratar',
          valor: `${valorTotalF}`,
          descricaoDataIndex: 'aContratarFormatado',
        },
        {
          colunaPrincipal: 'G = B + D + F',
          colunaSegundaria: 'Forecast',
          valor: `${valorTotalG}`,
          descricaoDataIndex: 'forcastFormatado',
        },
        {
          colunaPrincipal: 'H = A - G',
          colunaSegundaria: 'Saldo',
          valor: `${valorTotalH}`,
          descricaoDataIndex: 'saldoFormatado',
        },
      ] as tipoColuna[];
      setTotalizador(array);
    } else {
      setTotalizador([]);
    }
  }, [
    cicloOrcamentarioProjetoPacote,
    valorTotalA,
    valorTotalB,
    valorTotalC,
    valorTotalD,
    valorTotalE,
    valorTotalF,
    valorTotalG,
    valorTotalH]);

  const columns = useMemo(() => {
    if (totalizador) {
      let colluns: ColumnProps<any>[] = [
        {
          title: 'N',
          dataIndex: 'dataIndex',
        },
        {
          title: 'CÓDIGO',
          dataIndex: 'codPacote',
          filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <Form>
              <Row>
                <FormInput
                  placeholder="Pesquisar CÓD. PROJETO"
                  name="codPacote"
                  style={{ marginTop: '15px' }}
                  onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                  onPressEnter={() => {
                    if (typeof confirm === 'function') confirm();
                  }}
                />
              </Row>
              <Row>
                <Col span={6}>
                  <Button
                    type="primary"
                    style={{ marginLeft: '5px' }}
                    onClick={() => {
                      if (typeof confirm === 'function') confirm();
                    }}
                    icon="commons-search"
                    size="small">
                    Pesquisar
                  </Button>
                </Col>
                <Col span={6}>
                  <FormResetButton
                    size="small"
                    style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                    beforeReset={() => {
                      if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                    }}>
                    Limpar
                  </FormResetButton>
                </Col>
              </Row>
            </Form>
          ),
          filterIcon: filtered => {
            const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
            return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
          },
          onFilter: (value, record) =>
            record.codPacote !== undefined &&
            record.codPacote
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase()),
        },
        {
          title: 'NOME PACOTE',
          dataIndex: 'nomePacote',
          filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <Form>
              <Row>
                <FormInput
                  placeholder="Pesquisar CÓD. PROJETO"
                  name="nomePacote"
                  style={{ marginTop: '15px' }}
                  onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                  onPressEnter={() => {
                    if (typeof confirm === 'function') confirm();
                  }}
                />
              </Row>
              <Row>
                <Col span={6}>
                  <Button
                    type="primary"
                    style={{ marginLeft: '5px' }}
                    onClick={() => {
                      if (typeof confirm === 'function') confirm();
                    }}
                    icon="commons-search"
                    size="small">
                    Pesquisar
                  </Button>
                </Col>
                <Col span={6}>
                  <FormResetButton
                    size="small"
                    style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                    beforeReset={() => {
                      if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                    }}>
                    Limpar
                  </FormResetButton>
                </Col>
              </Row>
            </Form>
          ),
          filterIcon: filtered => {
            const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
            return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
          },
          onFilter: (value, record) =>
            record.nomePacote !== undefined &&
            record.nomePacote
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase()),
        },
      ];
      totalizador.map(tipoColuna => {

        if (tipoColuna.colunaSegundaria === 'Requisitado') {
          colluns.push({
            title: `${tipoColuna.valor}`,
            children: [
              {
                title: `${tipoColuna.colunaPrincipal}`,
                children: [
                  {
                    title: `${tipoColuna.colunaSegundaria}`,
                    dataIndex: `${tipoColuna.descricaoDataIndex}`,
                    align: 'center',
                    render: (text, record, index) => {
                      return gerarLinkRequisitado(record);
                    }
                  },
                ],
              },
            ],
          });

        } else {

          colluns.push({
            title: `${tipoColuna.valor}`,
            children: [
              {
                title: `${tipoColuna.colunaPrincipal}`,
                children: [
                  {
                    title: `${tipoColuna.colunaSegundaria}`,
                    dataIndex: `${tipoColuna.descricaoDataIndex}`,
                    align: 'center',
                  },
                ],
              },
            ],
          });

        }


      });

      return colluns;
    }
    return [];
  }, [totalizador]);


  const gerarLinkRequisitado = (record: CicloOrcamentarioProjetoPacoteResult) => {
    if (record.requisitado != 0.00 && record.children === undefined) {
      return <LinkRequisitadoProjeto
        projetoId={projetoId}
        codigoPacote={record.ordemInvestimentoCodPacote}
        descricaoLink={record.requisitadoFormatado}
      />
    }
    return <> {record.requisitadoFormatado} </>
  }

  const handleFilterExportar = () => {
    if (projetoId)
      getCicloOrcamentarioProjetoPacoteExportaExcel(projetoId);
  }


  const btnExportar = () => {
    return [
      <Button
        type="primary"
        name="btnExportar"
        icon="files-ms_excel"
        onClick={() => {
          handleFilterExportar()
        }}>
        <FormatText id="data-export" uppercase transform={() => "Exportar Relatório"} />
      </Button>,
    ];
  }

  const calcularCabecalhoDaTabela = (extra: TableCurrentDataSource<CicloOrcamentarioRelatorioResult>) => {
    let totalA = 0;
    let totalB = 0;
    let totalC = 0;
    let totalD = 0;
    let totalE = 0;
    let totalF = 0;
    let totalG = 0;
    let totalH = 0;

    extra.currentDataSource.map((item) => {
      totalA += item.orcadoAno;
      totalB += item.contratado;
      totalC += item.executado;
      totalD += item.requisitado;
      totalE += item.compromissado;
      totalF += item.aContratar;
      totalG += item.forcast;
      totalH += item.saldo;
    });

    setValorTotalA(formatCurrencyBr(totalA));
    setValorTotalB(formatCurrencyBr(totalB));
    setValorTotalC(formatCurrencyBr(totalC));
    setValorTotalD(formatCurrencyBr(totalD));
    setValorTotalE(formatCurrencyBr(totalE));
    setValorTotalF(formatCurrencyBr(totalF));
    setValorTotalG(formatCurrencyBr(totalG));
    setValorTotalH(formatCurrencyBr(totalH));

  }

  return (
    <>
      {totalizador && cicloOrcamentarioProjetoPacote ? (
        <Collapse bordered={false} defaultActiveKey={['1']} expandIcon={() => <Icon type="arrows-right_4" />}>
          <Panel key="1" header="PACOTE ANUAL" style={{ border: 0 }}>
            <Widget
              actions={btnExportar()}>
              {/* <Table
                className="groupedTable"
                rowKey={() => {
                  return newGuid();
                }}
                key={'tablePacote'}
                columns={columns}
                dataSource={cicloOrcamentarioProjetoPacote.result}
                pagination={configPaginacao}
                onChange={(pagination, filters, sorter, extra) => {
                  calcularCabecalhoDaTabela(extra);
                }}
              /> */}
              <AbaCicloOrcamentarioPacoteTabela
                cicloOrcamentarioProjetoPacote={cicloOrcamentarioProjetoPacote}
                pageSize={pageSize}
                projetoId={projetoId}
              />
            </Widget>
          </Panel>
        </Collapse>
      ) : (
        <> </>
      )}
    </>
  );
};

export default AbaPacote;
